interface DocumentBulkActionsProps {
  selectedCount: number;
  onDownload: () => void;
  onDelete: () => void;
}

export default function DocumentBulkActions({
  selectedCount,
  onDownload,
  onDelete,
}: DocumentBulkActionsProps) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="w-full bg-white shadow-lg rounded-lg border px-6 py-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">
          {selectedCount}개 선택됨
        </span>

        <div className="flex gap-2">
          <button
            onClick={onDownload}
            className="px-4 py-2 bg-black text-white text-sm rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            문서 다운로드
          </button>

          <button
            onClick={onDelete}
            className="px-4 py-2 bg-red-500 text-white text-sm rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
          >
            삭제
          </button>
        </div>
      </div>
    </div>
  );
}